var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5934_59032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9993 16.6689C31.6194 16.6689 16.666 31.6223 16.666 50.0023C16.666 68.3808 31.6246 83.3356 49.9993 83.3356C68.4104 83.3356 83.3327 68.3432 83.3327 50.0023C83.3327 31.6223 68.3793 16.6689 49.9993 16.6689ZM49.9993 78.9878C43.2113 78.9878 36.9617 76.6415 32.0164 72.7184C35.0783 65.576 42.1284 60.8719 49.9993 60.8719C57.8715 60.8719 64.9229 65.5749 67.9853 72.716C63.0396 76.6404 56.7888 78.9878 49.9993 78.9878ZM39.1298 45.6545C39.1298 39.661 44.0059 34.785 49.9993 34.785C55.9928 34.785 60.8689 39.661 60.8689 45.6545C60.8689 51.648 55.9928 56.524 49.9993 56.524C44.0059 56.524 39.1298 51.648 39.1298 45.6545ZM71.3299 69.6059C68.643 64.3107 64.1005 60.2607 58.6743 58.1497C62.6255 55.3981 65.2168 50.8236 65.2168 45.6545C65.2168 37.2636 58.3902 30.437 49.9993 30.437C41.6085 30.437 34.7819 37.2636 34.7819 45.6545C34.7819 50.8239 37.3734 55.3986 41.3251 58.1502C35.8996 60.2618 31.3581 64.3127 28.6715 69.6089C23.9199 64.4443 21.0138 57.5566 21.0138 50.0023C21.0138 34.0197 34.0167 21.0167 49.9993 21.0167C65.982 21.0167 78.9849 34.0197 78.9849 50.0023C78.9849 57.5553 76.0799 64.4417 71.3299 69.6059Z",
    fill: "#667084"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5934_59032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.6667,
    height: 66.6667,
    fill: "white",
    transform: "translate(16.667 16.667)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.5f92396efd572858ae2b583178218b93.svg";
export { ForwardRef as ReactComponent };